export enum ShiftAmount {
    LSL0 = 0,
    LSL16 = 16,
    LSL32 = 32,
    LSL48 = 48
}